var React = require('react');

function Line (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M.001 18h39.997v4H.001z"}));
}

Line.defaultProps = {"viewBox":"0 0 40 40","fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"1.414"};

module.exports = Line;

Line.default = Line;
